import React from 'react';
import { Flex } from 'components/base/layout-components';
import Icon from 'components/base/Icon';
import Text from 'components/base/Text';

const GroupWidgetNoData = () => {
  return (
    <Flex height='6rem' direction='column' pt='1.2rem'>
      <Icon
        size='large'
        name='NoEntry'
        color='botticelli'
        style={{ marginLeft: '1.5rem' }}
      />
      <Text color='shuttleGray' lineHeight='1.2' ml='2rem' pt='0.9rem'>
        NO DATA TO PRESENT
      </Text>
    </Flex>
  );
};

export default GroupWidgetNoData;
